import axios from 'axios/index';

export default function addEditBillingInformation(contractRate, config) {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };

  const url = config.postBillingInformation;
  return dispatch => dispatch({
    type: 'ADD_EDIT_BILLING_INFORMATION_SAVE',
    payload: axios({ method: 'post', url, headers, data: { contractRate } })
  });
}


// WEBPACK FOOTER //
// ./src/actions/addEditBillingInformation.js